/**
 * Value for a data attribute given a condition.
 */
export function boolDataAttr(
  condition: boolean | null | undefined,
): string | undefined {
  return condition ? "" : undefined;
}
